import type { IssueAssessmentHistoryResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetIssueAssessmentHistoryQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  GetIssueAssessmentHistoryDocument,
  Parent_Type_Enum,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type IssueAssessmentHistoryArgs = {
  startDate?: string | null;
  endDate?: string | null;
};

export const useGetIssueAssessmentHistory = createQueryHook<
  IssueAssessmentHistoryArgs,
  IssueAssessmentHistoryResponseRow[],
  GetIssueAssessmentHistoryQuery
>({
  trpcQueryOptions: (trpc, args) =>
    trpc.frontend.issueAssessment.getHistory.queryOptions({
      startDate: args.startDate ?? null,
      endDate: args.endDate ?? null,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    issue_assessment_audit: data,
  }),
  graphqlDocument: GetIssueAssessmentHistoryDocument,
  graphqlVariables: (args) => {
    const hasRange = !!args.startDate && !!args.endDate;

    return {
      where: {
        Type: {
          _eq: Parent_Type_Enum.IssueAssessment,
        },
        ...(hasRange && {
          _or: [
            { ActualCloseDate: { _gte: args.startDate } },
            { CreatedAtTimestamp: { _lte: args.endDate } },
          ],
        }),
      },
    };
  },
});
